module.exports = __webpack_public_path__ + "img/drone.3370a962.jpg";